import classnames from 'classnames'
import * as React from 'react'

import { Button, ButtonHTMLProps, ButtonProps, ButtonTheme, ButtonThemeType } from '../button'
import { Icon } from '../icon'
import { PopoverStateReturn, PopoverTrigger } from '../popover'

function getButtonProps(theme: ButtonTheme, active: boolean): ButtonProps & ButtonHTMLProps {
  switch (theme) {
    case ButtonTheme.light:
      return {
        theme: 'transparent',
        contentClass: 'font-normal truncate',
        className: classnames(
          'border bg-white pr-1 disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-500 dark:bg-gray-800',
          {
            'border-gray-100 hover:border-gray-300 disabled:hover:border-gray-100 dark:border-gray-600 dark:hover:border-gray-400 dark:disabled:border-gray-700':
              !active,
            'border-blue-400 dark:border-blue-400': active,
          }
        ),
        rightContent: (
          <Icon
            name="caretDown"
            className={classnames({
              'text-gray-300 dark:text-gray-500': !active,
              'text-blue-400': active,
            })}
          />
        ),
      }
    case ButtonTheme.dark:
      return {
        theme: 'transparent',
        contentClass: 'font-normal truncate',
        className: classnames('border bg-gray-800 pr-1 text-gray-50 disabled:border-gray-700 disabled:text-gray-500', {
          'border-gray-600 hover:border-gray-400': !active,
          'border-blue-400': active,
        }),
        rightContent: (
          <Icon
            name="caretDown"
            className={classnames({
              'text-gray-500': !active,
              'text-blue-400': active,
            })}
          />
        ),
      }
    default:
      return {}
  }
}

interface SelectButtonProps extends ButtonProps, ButtonHTMLProps {
  /**
   * Theme for the button
   *
   * @default light
   */
  theme?: ButtonThemeType

  state: PopoverStateReturn
}

export function SelectButton({ state, theme = 'light', ...props }: SelectButtonProps) {
  const themeProps = React.useMemo(() => getButtonProps(ButtonTheme[theme], state.visible), [theme, state.visible])

  return (
    <Button
      {...themeProps}
      {...props}
      as={PopoverTrigger}
      state={state}
      contentClass={classnames(themeProps.contentClass, props.contentClass)}
      className={classnames(themeProps.className, props.className)}
      type="button"
      active={props.active ?? state.visible}
      theme={themeProps.theme ?? theme}
    >
      {props.children}
    </Button>
  )
}
